import Moment from "moment"
import { extendMoment } from "moment-range"

const moment = extendMoment(Moment)
moment.locale("es")

export const ageByBirthdate = date => {
  const age = moment().diff(date, "years", true)
  return Math.floor(age)
}